/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Clients_Tags_CountInputs */

const cs_clients_tags_count = /** @type {(inputs: Clients_Tags_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} klientů`)
};

const en_clients_tags_count = /** @type {(inputs: Clients_Tags_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} clients`)
};

/**
* | output |
* | --- |
* | "{count} clients" |
*
* @param {Clients_Tags_CountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_tags_count = /** @type {((inputs: Clients_Tags_CountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Tags_CountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_tags_count(inputs)
	return cs_clients_tags_count(inputs)
});